import React from 'react';

export const UsersSkeleton = () => {
  // Crear un array con identificadores únicos
  const skeletonRows = [
    'row-a1',
    'row-b2',
    'row-c3',
    'row-d4',
    'row-e5',
    'row-f6',
    'row-g7',
    'row-h8',
    'row-i9',
    'row-j10',
  ];

  return (
    <div className='max-w-[850px] mx-auto px-4 md:px-0 min-h-screen pt-8 md:pt-14'>
      {/* Back button skeleton */}
      <div className='rounded-full w-max mb-4 md:mb-6 p-2 bg-gray-200 animate-pulse' />

      {/* Header section skeleton */}
      <div className='flex items-center mx-auto flex-col gap-y-3 text-center'>
        {/* Avatar skeleton */}
        <div className='overflow-hidden w-[100px] h-[100px] rounded-lg bg-gray-200 animate-pulse' />

        {/* Text content skeleton */}
        <div className='flex flex-col gap-y-1 w-full items-center'>
          <div className='h-8 w-48 bg-gray-200 rounded-sm animate-pulse' />
          <div className='h-6 w-36 bg-gray-200 rounded-sm animate-pulse' />
        </div>
      </div>

      {/* Tabs skeleton */}
      <div className='flex justify-center items-center pt-8 pl-4 pb-0 overflow-x-auto w-full'>
        <div className='inline-block whitespace-nowrap space-x-2 text-primary space-x-2'>
          {[1, 2, 3].map((tab) => (
            <div
              key={tab}
              className='inline-block whitespace-nowrap py-1.5 px-3 xs:py-2 xs:px-4 rounded-full bg-gray-200 animate-pulse w-16'
            />
          ))}
        </div>
      </div>

      {/* Page title skeleton */}
      <div className='h-8 w-56 bg-gray-200 rounded-sm animate-pulse mt-8 md:mt-6 mb-4 md:mb-6' />

      {/* Header bar skeleton */}
      <div className='flex flex-col justify-between gap-6 w-full flex-wrap pb-6 xs:pb-8'>
        <div className='flex gap-2 md:items-center w-full flex-nowrap justify-between'>
          {/* Search bar skeleton */}
          <div className='w-full min-w-fit max-w-md shrink-0 xs:w-96 h-10 bg-gray-200 rounded-sm animate-pulse' />

          {/* Button skeletons */}
          <div className='flex gap-2 items-center'>
            <div className='w-24 h-10 bg-gray-200 rounded-sm animate-pulse' />
            <div className='w-10 h-10 bg-gray-200 rounded-sm animate-pulse' />
          </div>
        </div>
      </div>

      {/* Table skeleton */}
      <div className='flex flex-col'>
        {/* Table header */}
        <div className='w-full mb-2'>
          <div className='h-12 w-full bg-gray-200 rounded-sm animate-pulse' />
        </div>

        {/* Table rows */}
        {skeletonRows.map((id, index) => (
          <div
            key={id}
            className='h-16 w-full bg-gray-200 rounded-sm my-2 animate-pulse'
            style={{ animationDelay: `${index * 0.05}s` }}
          />
        ))}
      </div>
    </div>
  );
};
